<template>
	<div id="reception_qr">
		<div class="container">
			<div v-if="receptionToken" class="qrcode complet">
				<vue-qrcode :value="receptionToken" :options="qroption" tag="img"></vue-qrcode>
			</div>
		</div>
	</div>
</template>

<script>
	import VueQrcode from "@chenfengyuan/vue-qrcode";
	export default {
		components: {
			VueQrcode
		},
		props: {
			token: { type: String },
		},
		data () {
			return {
				option: {
					errorCorrectionLevel: "M",
					maskPattern: 0,
					margin: 10,
					scale: 2,
					width: 128,
					color: {
						dark: "#000000FF",
						light: "#FFFFFFFF"
					}
				}
			}
		},
		computed: {
			receptionToken() {
				const response = this.$store.getters['commonStore/getResponseRunstReception'];
				if(this.token == 'only') return response ? response.token : ''
				return response ? response.reception_url : ''
			},
		},
		methods: {
		},
		mounted() {
		}
	};
</script>

<style lang="scss" scoped>
	#reception_qr {
		.container {
		}
	}
</style>
